export enum EnterpriseCertificateStatus {
    UNOPENED, // 未开启
    ACTIVATED, // 已启用
    TERMINATED // 已停用
}

export enum EnterpriseCertificateTaskStatus {
    NotAcquired = 0, // 0-未获取证书
    Acquired = 1, // 1-已获取证书
    LoseEfficacy = 2 // 2-已失效
}

// 学习证书关联内容类型
export enum CertificateRelateContentType {
    course = 1,
    program = 2
}

export interface EnterpriseCertificate {
    id: string;
    status: EnterpriseCertificateStatus;
    task_status?: EnterpriseCertificateTaskStatus;
}

interface EnterpriseCertificateBaseInfo {
    id: string;
    name: string;
    is_repetitive_mode: number;
    valid_period: number;
    status: EnterpriseCertificateStatus;
}

type EnterpriseCertificateSetUp = Record<string, number>;

interface EnterpriseCertificateInfo extends EnterpriseCertificateBaseInfo {
    certificate_id: string;
    name: string;
    valid_period: number;
    teacher_name?: string;
    course_id?: string; // 兼容性字段，之后会废弃
    obj_id: string;
    obj_type: number;
    is_close_course_certificate: number;
    is_repetitive_mode: number;
    title: string;
    text: string;
    issue_enterprise: string;
    logo: string;
    theme_background: string;
    theme_img: string;
    setup: EnterpriseCertificateSetUp;
    depend_learning_task: number;
    is_top: number;
}

export interface EnterpriseCertificateRelateInfo {
    id: string;
    type: number;
    title: string;
    copy_num: number;
    access_code: string;
    course_num?: number;
    session_num?: number;
    module_num?: number;
    latest_course_id?: string;
    show_pic?: string;
    mode?: number;
    share_url: string;
}

export interface EnterpriseCertificateStat {
    no_acquired_num: number;
    expired_num: number;
    effective_num: number;
    assign_student_num?: number;
    course_participate_num?: number;
}

export enum EnterpriseCertificateGetCertificateMode {
    TASK_IN_PROGRESS = '1',
    NORMAL_ACQUISITION = '2',
    OVERDUE_ACQUISITION = '3',
    MISSION_FAILURE = '4',
    TASK_WITHDRAWAL = '5',
    TASK_OVERDUE_NOT_COMPLETED = '6'
}

export interface EnterpriseCertificateStudentCertificateInfo {
    certificate_task_status: string;
    create_time: string;
    effective_ts: string;
    enterprise_id: string;
    expire_ts: string;
    get_certificate_mode: EnterpriseCertificateGetCertificateMode;
    grant_ts: string;
    id: string;
    certificate_status: number;
    student_certificate_status: string;
    update_time: string;
    is_show_update_btn?: number;
    assign_url?: string;
}

export interface EnterpriseCertificateItemInfo {
    certificate_base_info: EnterpriseCertificateInfo;
    relate_info: EnterpriseCertificateRelateInfo;
    relate_course_info?: EnterpriseCertificateRelateInfo; // 兼容性字段，之后会废弃
    current_obj_info?: EnterpriseCertificateRelateInfo;
    current_course_info?: EnterpriseCertificateRelateInfo;
    certificate_stat: EnterpriseCertificateStat;
    student_certificate_info: EnterpriseCertificateStudentCertificateInfo;
    student_info: {
        umu_id: string;
        user_name: string;
        number: string;
        uid: string;
    };
}
